class ProductDetail extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.updateMobilePreviewHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      window,
      'load',
      this.updateMobilePreviewHeight.bind(this),
    )
    this.listeners.add(
      window,
      'resize',
      this.updateMobilePreviewHeight.bind(this),
    )

    if (this.els?.dragger?.exists) {
      this.els.dragger.elements.forEach(dragger => {
        // Bind click event to scroll up
        this.listeners.add(dragger, 'click', this.scrollToMain.bind(this))

        // Bind drag start event to the dragger element
        this.listeners.add(
          dragger,
          'touchstart',
          this.handleDragStart.bind(this),
        )
        this.listeners.add(
          dragger,
          'mousedown',
          this.handleDragStart.bind(this),
        )

        // Bind drag move and end events to the document to track even outside dragger
        this.listeners.add(
          document,
          'touchmove',
          this.handleDragMove.bind(this),
        )
        this.listeners.add(
          document,
          'mousemove',
          this.handleDragMove.bind(this),
        )

        this.listeners.add(document, 'touchend', this.handleDragEnd.bind(this))
        this.listeners.add(document, 'mouseup', this.handleDragEnd.bind(this))
        this.listeners.add(
          document,
          'mouseleave',
          this.handleDragEnd.bind(this),
        )
      })
    }
  }

  handleDragStart (e) {
    const isDesktop = window.innerWidth > 999
    if (isDesktop) return

    this.dragging = true
    this.startY = e.touches ? e.touches[0].clientY : e.clientY
  }

  handleDragMove (e) {
    if (!this.dragging) return

    const currentY = e.touches ? e.touches[0].clientY : e.clientY

    // If user drags upward (i.e., currentY is less than startY), trigger the scroll
    if (this.startY > currentY) {
      this.scrollToMain()
      this.dragging = false // Reset the flag to prevent multiple triggers during one drag session
    }
  }

  handleDragEnd () {
    this.dragging = false // Reset dragging flag after drag ends
  }

  scrollToMain () {
    const isDesktop = window.innerWidth > 999
    if (isDesktop) return

    const rect = this.els.main.element.getBoundingClientRect()
    const offsetTop = rect.top + window.scrollY

    window.scrollTo({ top: offsetTop, behavior: 'smooth' })
  }

  updateMobilePreviewHeight () {
    if (this.els?.preview?.element) {
      document.documentElement.style.setProperty(
        '--ProductDetail_Height',
        `${this.els.preview.element.clientHeight}px`,
      )
    }
  }
}

if (!customElements.get('product-detail')) {
  customElements.define('product-detail', ProductDetail)
}
